<template>
  <template v-for="item in unitIconIndexs" :key="item.resourceName">
    <AttrImage
      :label="`请上传“${item.label}”`"
      :base64="getUnitValue(item.resourceName)"
      @change="(imagePath: string) => onUnitUpload(item.resourceName,imagePath)"
      @delete="() => onUnitDelete(item.resourceName)"
    />
  </template>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { PropType } from 'vue';
import { Shape } from '@/services/shape';
import { useEditorStore } from '@/store/use-editor-store';
import { ResourceKey } from '@/services/shape/attributes';
import { getWidgetArrayUnitIconIndexs } from '@/hooks/use-image-array';

const editorStore = useEditorStore();

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

// 数据源单位
const unitIconIndexs = computed(() => {
  return getWidgetArrayUnitIconIndexs(props.shape);
});

const getUnitValue = (resourceName: ResourceKey) => {
  return props.shape.getResources({
    resourceName,
    colorGroup: editorStore.themeColorId,
    base64: true
  })?.[0];
};

const onUnitUpload = (resourceName: ResourceKey, unitImgPath: string) => {
  props.shape?.uploadResource({
    resourceName,
    colorGroup: editorStore.themeColorId,
    realpath: unitImgPath
  });
};
const onUnitDelete = (resourceName: ResourceKey) => {
  props.shape?.deleteResource({
    resourceName,
    colorGroup: editorStore.themeColorId
  });
};
</script>
